import { socket } from '../providers/socket';
import { SDP } from './sdp';
import { EventTypeEnum, Packet } from '@matap/shared';

export class PeerSocket {
  constructor(
    private conferenceId: string,
    private toUserId: string,
  ) {}

  public emit(sdp: SDP) {
    sdp.toUserId = this.toUserId;
    sdp.conferenceId = this.conferenceId;
    socket.emit(EventTypeEnum.EXCHANGE_SDP, { payload: sdp } as Packet);
  }
}
